export enum AnalyticsAction {
  CLICKED = 'CLICKED',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  SETTINGS_CHANGED = 'SETTINGS_CHANGED',
  NAVIGATION = 'NAVIGATION',
  OPEN_IN_NEW_TAB = 'OPEN_IN_NEW_TAB', // a new tab is opened for a service case (existing or newly created)
  SWITCH_TO_OPEN_TAB = 'SWITCH_TO_OPEN_TAB',
  CLOSE_OPEN_TAB = 'CLOSE_OPEN_TAB', // an opened tab has been closed
  VEHICLE_SEARCH = 'VEHICLE_SEARCH',
  PROCESS_KPI_OPT_IN = 'PROCESS_KPI_OPT_IN',
}
